import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { createEInvoicingKYC } from '../query-api'

export interface UseEInvoicingCreateKYCError {
  body: {
    title: string
    detail: string
    type: string
    extensions: object
    status: number
    internal: {
      cause: Error
    }
  }
}

interface UseEInvoicingCreateKYCOptions {
  onError?: (error: UseEInvoicingCreateKYCError) => void
}

export const useEInvoicingCreateKYC = ({ onError }: UseEInvoicingCreateKYCOptions) => {
  const { organization } = useUserOrganization()

  const { mutateAsync, isLoading } = useMutation(QueryKeys.EInvoicingCreateKYC, createEInvoicingKYC(organization), {
    onError,
  })

  return {
    createKYC: mutateAsync,
    isLoading,
  }
}
